import { Box } from '@mui/material';
import { IFeature } from '../data/types';
import FeatureCard from './FeatureCard';
import PromoHeader from './PromoHeader';

interface HeroSectionProps {
    features: IFeature[];
    onOpen: (feature: IFeature) => void;
}

const HeroSection = ({ features, onOpen }: HeroSectionProps) => {
    if (!features.length) return null;

    const promo = features.find((feature) => feature.promoHeader)?.promoHeader;

    return (
        <Box
            component="section"
            dir="rtl"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                gap: 1.5
            }}
        >
            {promo && (
                <Box sx={{ width: '100%', maxWidth: { xs: '100%', sm: 520, md: 560 } }}>
                    <PromoHeader text={promo} />
                </Box>
            )}
            {features.map((feature) => (
                <Box
                    key={feature.id}
                    sx={{
                        width: '100%',
                        maxWidth: { xs: '100%', sm: 520, md: 560 }
                    }}
                >
                    <FeatureCard feature={feature} variant="spotlight" onOpen={onOpen} />
                </Box>
            ))}
        </Box>
    );
};

export default HeroSection;
